import type { EndUsersListParams } from '../types/end-users.types';

export const endUserKeys = {
  all: ['end-users'] as const,
  lists: () => [...endUserKeys.all, 'list'] as const,
  list: (params: EndUsersListParams) => [...endUserKeys.lists(), params] as const,
  details: () => [...endUserKeys.all, 'detail'] as const,
  detail: (id: string) => [...endUserKeys.details(), id] as const,
};
